import {EntityState, createEntityAdapter} from '@ngrx/entity';
import {createFeatureSelector} from '@ngrx/store';
import {DynForm} from '../domain/meta/dyn-form';
import * as actions from './subform.actions';

export const subformAdapter = createEntityAdapter<DynForm>();
export interface State extends EntityState<DynForm> { }

export const initialState: State = subformAdapter.getInitialState();

export function reducer(
    state: State = initialState,
    action: actions.SubformActions
): State {
    switch (action.type) {

        case actions.CREATE_SUCCESS:
            return subformAdapter.addOne(action.form, state);

        case actions.UPDATE_SUCCESS:
            return subformAdapter.updateOne({
                id: action.id,
                changes: action.changes
            }, state);

        case actions.DELETE_SUCCESS:
            return subformAdapter.removeOne(action.id, state);

        case actions.LOAD_ALL_SUCCESS:
            return subformAdapter.addAll(action.forms, state);

        default:
            return state;
    }
}

export const getSubformState = createFeatureSelector<State>('subforms');

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal,
} = subformAdapter.getSelectors(getSubformState);



// WEBPACK FOOTER //
// ./src/app/forms/state/subform.reducer.ts